
export default {
  data () {
    return {
      originCommunityId: undefined,
      selectedCityId: '',
      visible: false,
      modalTitle: '新增采集系统',
      formList: [
        {
          label: '城市',
          inputType: 'cascader',
          options: [],
          handle: e => this.cityChange(e, 3),
          placeholder: '请选择城市',
          props: ['areasList', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '智慧安防小区系统标识',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入智慧安防小区系统标识',
          props: ['systemMark', {
            rules: [
              {required: true, message: '请输入智慧安防小区系统标识'},
              {min: 1, max: 100, message: '小区系统标识长度为1-100位'}
            ]
          }]
        },
        {
          label: '智慧安防小区系统名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入智慧安防小区系统名称',
          props: ['systemName', {
            rules: [
              {required: true, message: '请输入智慧安防小区系统名称'},
              {min: 1, max: 100, message: '小区系统名称长度为1-100位'}
            ]
          }]
        },
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择所属小区',
          fetchOptions: this.getOptions,
          props: ['communityId', {
            rules: [{required: true, message: '请选择所属小区'}]
          }]
        },
        {
          label: '账号',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入账号',
          props: ['csAccount', {
            rules: [
              {required: true, message: '请输入账号'},
              {min: 1, max: 50, message: '账号长度为1-50位'}
            ]
          }]
        },
        {
          label: '密码',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入密码',
          props: ['csPwd', {
            rules: [
              {required: true, message: '请输入密码'},
              {min: 1, max: 100, message: '密码长度为1-100位'}
            ]
          }]
        }
      ],
      formKey: {
        areasList: undefined,
        systemMark: undefined,
        systemName: undefined,
        communityId: undefined,
        csAccount: undefined,
        csPwd: undefined
      },
      addParam: {
        url: '/coll/system/add',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: () => this.addResHandle('add')
      },
      editParam: {
        url: '/coll/system/edit/',
        resHandle: () => this.addResHandle('edit')
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    getOptions (pageNum, search, item) {
      return this.communitySelectByStep(pageNum, search, undefined, 3, undefined, item.areas);
    },
    cityChange (cityId, index) {
      let id = cityId && cityId.length ? Number(cityId[1]) : undefined;
      this.$refs.addEdit.resetSubValue(['communityId']);
      this.formList[3].areas = undefined;
      if (!id) { return false; }
      this.formList[3].areas = cityId;
      // this.belongCommunitySelect(id, index);
      this.communitySelectByStep(1, undefined, undefined, 3, undefined, cityId);
    },
    belongCommunitySelect (id, index) {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/coll/system/getAddCommunity',
          params: { cityId: id }
        }).then(({ data }) => {
          this.formList[index].options = data;
          resolve(data);
        });
      });
    },
    openModal () {
      this.modalTitle = '新增采集系统';
      this.formList[0].disabled = false;
      this.formList[0].options = this.cityList;
      this.visible = true;
    },
    /** 编辑 */
    async editCollect (row) {
      this.selectedCityId = row.cityId;
      this.modalTitle = '编辑采集系统';
      this.formList[0].options = this.cityList;
      this.formList[0].disabled = true;
      this.visible = true;
      let values = {};
      for (let item in row) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = row[item];
        }
      }

      const list = await this.belongCommunitySelect(row.cityId, 3) || [];
      if (!list.length || !list.some(item => item.value === values.communityId)) {
        this.originCommunityId = values.communityId;
        values.communityId = row.communityName;
      }
      console.log('values: ', values);

      this.$nextTick(() => {
        this.$refs.addEdit.routeQuery = row.csId;
        this.$refs.addEdit.form.setFieldsValue(values);
      });
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      param.cityId = this.selectedCityId;
      if (this.originCommunityId) {
        param.communityId = this.originCommunityId;
        this.originCommunityId = undefined;
      }
      return param;
    },
    addResHandle (type) {
      this.$message.success(type === 'add' ? '新增成功' : '编辑成功');
      this.visible = false;
      this.getCommunitySelect(undefined, 1);
      this.$refs.table.getTableList();
    },
    editResHandle (res) {
      return res;
    }
  }
};
